import * as yup from 'yup';
import type { ValidationError } from 'yup';
import type { SasProduct } from './getTemplate';
import primarySasSchema from './primarySasSchema';

export type Logger = (error: Partial<ValidationError>, product?: string) => void;
export type ApplicantData = Record<string, unknown>;

function prepareSchema(product: SasProduct) {
  const productLookup = {
    default: primarySasSchema,
  };

  // @ts-ignore
  const schema = productLookup[product] ?? productLookup.default;
  return yup.object(schema);
}

async function validateSas(
  product: SasProduct,
  applicantData: ApplicantData = {},
  logger: Logger = () => { },
) {
  let validationError = {};
  try {
    const schema = prepareSchema(product);
    await schema.validate(applicantData, { abortEarly: true, recursive: true });
  } catch (error) {
    const { errors, message, params } = error as Partial<ValidationError>;
    validationError = { errors, message, params };
    logger(validationError, product);
  }

  return validationError;
}

export default validateSas;
